/**
 * Tarayıcı çeviri eklentileri (Google Translate vb.) sayfadaki metin
 * düğümlerini <font> ile sarar. Bu, React DOM'u güncellerken bazen
 * `insertBefore` / `removeChild` çağrılarının "node is not a child of this
 * node" ile çökmesine yol açar — `<html translate="no">` koysak bile bazı
 * eklentiler bunu yoksayar.
 *
 * Çözüm (facebook/react#11538): bu iki DOM metodunu güvenli hale getir —
 * referans düğüm farklı bir ebeveyne aitse fırlatmak yerine no-op yap. React
 * bir sonraki render'da ağacı zaten toparlar. Görünür bir yan etkisi yoktur,
 * yalnızca eklenti kaynaklı çökmeyi engeller.
 */
export function installDomTranslateGuard(): void {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
